module.exports = __webpack_public_path__ + "media/images/icons/productivity-cccf0fbe96959f88ecfc9955baf9c0ae.png";